/**
 * My requests, as its own screen (WALLIYO-0134).
 *
 * Every workspace's sidebar lists it under the rule, beside the directory: what
 * you have asked to be allowed to do belongs to you, not to the department you
 * sit in, so it follows you into whichever workspace is showing.
 *
 * It was two sections at the bottom of the profile, below sign-out — which is
 * the one place nobody scrolls to. The design puts it in the sidebar, and this
 * is the screen that row opens.
 */

import { t } from "../../i18n";
import { PageTop } from "../../shell/PageTop";
import { AskForPermission } from "./AskForPermission";
import { MyRequests } from "./MyRequests";

export function MyRequestsScreen() {
  return (
    <>
      <PageTop title={t("screen.myRequests")} sub={t("myRequests.sub")} />
      <AskForPermission />
      <MyRequests />
    </>
  );
}
